import { rosterAPI } from '@/providers/apis/roster/roster';
import { Vue, Component } from 'vue-property-decorator';

@Component({
    name: 'academic',
})

export default class Academic extends Vue {

    // ------------------------------------------------------------------------
    // Properties
    private  filter: any = null;

    private currentPage: number = 1;

    private academic: any = [];

    private datas: any = [];

    // ---------------------------------------------------------------------------------
    // Hooks


    // ------------------------------------------------------------------------------
    // Methods

}
